import { render, staticRenderFns } from "./RegisterMinLocation.vue?vue&type=template&id=f044bb9a&scoped=true"
import script from "./RegisterMinLocation.vue?vue&type=script&lang=js"
export * from "./RegisterMinLocation.vue?vue&type=script&lang=js"
import style0 from "./RegisterMinLocation.vue?vue&type=style&index=0&id=f044bb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044bb9a",
  null
  
)

export default component.exports